import React, { useState } from 'react'
import useMerchantPortalAxios from '../utils/axios';
import { useDispatch } from 'react-redux';
import { setEmployeeEligiblity } from '../features/cfcLoanSlice';

function useCfcLoanApi () {

    const MerchantPortalAxios = useMerchantPortalAxios();

    const [loading, setLoading] = useState(false);
    const [totalNbPage, setTotalNbPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);

    const dispatch = useDispatch();


    const GetEmployeeLoanEligiblity = async (pageNumber) => {
        setLoading(true);
        await MerchantPortalAxios.post('/v1/Cfc/GetEmployeeLoanEligiblity', {
                SessionID: sessionStorage.getItem("SessionID"),
                PageNumber: pageNumber,
                PageSize: 10
            }).then((res) => {
                dispatch(setEmployeeEligiblity(res.data.Payload.Employees));
                if(res.data.Payload.length === 0) {
                    setTotalNbPage(0)
                    setTotalCount(0)
                } else {
                    setTotalNbPage(res.data.Payload.PageCount);
                    setTotalCount(res.data.Payload.TotalEmployeesCount);
                }
            }).finally(() => {
                setLoading(false)
            })
    }

    const UpdateEmployeeLoanEligibility = async (payload) => {
        const response = await MerchantPortalAxios.post('/v1/Cfc/UpdateEmployeeLoanEligibility', payload);

        return response.data.Payload;
    }

  return {
    GetEmployeeLoanEligiblity,
    // employeeEligiblity,
    loading,
    totalCount,
    totalNbPage,
    UpdateEmployeeLoanEligibility
  }}


export default useCfcLoanApi;